export default "__VITE_ASSET__CVosPNWe__"